
import axios, { AxiosResponse } from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import TuEstadoCuentaForm from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaForm.vue";
import TuEstadoCuentaResult from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaResult.vue";
import Swal from "sweetalert2";
import Axios from "axios";
import Inputmask from "inputmask";
import VueRecaptcha from "vue-recaptcha";
import MatrixPicker from "@/components/Matrix_Picker/MatricPicker.vue";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import CambioPasswordService from "@/services/CambioPasswordService";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import UserData from "@/models/CambioPassword/UserData";
import CambioPasswordRequest from "@/models/CambioPassword/CambioPasswordRequest";
import MaskedInput from "vue-text-mask";
import { mask } from "vue-the-mask";
import { directive } from "vue/types/umd";
import { uid } from "ets-fingerprintjs";
import { Buffer } from "buffer";
import AfiliadoService from "@/services/AfiliadoService";

Vue.directive("input-mask", {
  update: function (el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
});

@Component({
  components: {
    TuEstadoCuentaForm,
    TuEstadoCuentaResult,
    MatrixPicker,
    VueRecaptcha,
    MaskedInput,
  },
  directives: {
    mask,
  },
})
export default class CambioPassword extends Vue {
  public CambioPasswordService: CambioPasswordService =
    new CambioPasswordService();
  public showCaptchaMessage: boolean = false;
  public formIndex: number = 1;
  public cedulaAfiliado: string = "";
  public viaRecuperacionValue: string = "";
  public viaRecuperacionValueFormated: string = "";
  public OTPCodeConfirmation: string = "";
  public newPassword: string = "";
  public newPasswordConfirmation: string = "";
  public viaComunicacionCheckValue: string = "";
  public userData = new UserData();
  public captchaToken: string = "";
  public buttonLoading: boolean = false;
  public cambioPasswordRequest: CambioPasswordRequest =
    new CambioPasswordRequest();
  public OTPCodeTextInput: string = "";
  public showCodeOTPErrorMessage: boolean = false;
  public OTPValidationSuccsess: boolean = false;
  showSecondStepError: boolean = false;
  passCumpleMin: boolean = false;
  passMayus: boolean = false;
  passMinus: boolean = false;
  passNum: boolean = false;
  passSpecial: boolean = false;
  passwordResestSuccess: boolean = false;
  timesOTCSend: number = 0;
  countdownTimer: number = 60;
  public timer: number = 60;
  public dumb: string = "";
  public showNoDataError: boolean = false;
  public reenviarLoading: boolean = false;
  public ip: string = "";
  public afiliadoService: AfiliadoService = new AfiliadoService();
  async mounted() {
    this.cambioPasswordRequest.canal = "PortalBe";
    this.hendleEncryptParams();
    this.ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
  }

  public async getUserData(): Promise<boolean> {
    this.buttonLoading = true;

    try {
      if (this.timesOTCSend >= 4) {
        this.buttonLoading = false;
        this.showErrorAlert(
          "Ha excedido la cantidad de intentos máxima. Inténtelo nuevamente más tarde."
        );
        return false;
      }

      if (!this.isCaptchaValid) {
        this.buttonLoading = false;
        this.showErrorAlert("Por favor, complete el captcha.");
        return false;
      }

      const resp = await this.CambioPasswordService.getUserData(
        this.cedulaNumbersOnly,
        uid.toString(),
        this.ip,
        this.captchaToken
      );

      if (!resp?.data?.payload || resp.data.payload.success === false) {
        if (resp.data.payload?.code == 204) {
          this.showWarningAlert();
          this.cedulaAfiliado = "";
          return false;
        }
        if (resp.data.payload?.code == 430) {
          this.showErrorAlert(resp.data.payload.message, "Ok", false, true);
          return false;
        }
        this.showErrorAlert(
          "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
        );
        return false;
      }

      if (
        !resp.data.payload.data?.celular &&
        !resp.data.payload.data?.email1 &&
        !resp.data.payload.data?.email2
      ) {
        this.showNoDataError = true;
        return false;
      }

      this.userData = resp.data.payload.data;
      this.countdown();
      return true;
    } catch {
      this.showErrorAlert(
        "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
      );
      return false;
    } finally {
      this.buttonLoading = false;
    }
  }

  returnHome() {
    window.location.href = GlobalConfig.PORTAL_BASE_URL;
  }

  public validateCaptcha() {}
  get isCaptchaValid(): boolean {
    return this.captchaToken != null && this.captchaToken.length > 0;
  }

  get firstStepValid(): boolean {
    return (
      this.isCaptchaValid &&
      this.userData != null &&
      this.userData.primerNombre != null &&
      this.userData.primerNombre != undefined
    );
  }
  get secondStepValid(): boolean {
    return !!this.cambioPasswordRequest.idToken;
  }
  get thirdStepValid(): boolean {
    return this.OTPValidationSuccsess;
  }
  get fourthStepValid(): boolean {
    return this.isCaptchaValid && this.passwordResestSuccess;
  }
  public async canContinue(): Promise<boolean> {
    var isValid = await this.validateForm();

    if (isValid) {
      switch (this.formIndex) {
        case 1:
          this.showCaptchaMessage = !this.isCaptchaValid;
          if (!this.isCaptchaValid) return false;
          await this.getUserData();
          return this.firstStepValid;
          break;
        case 2:
          this.buttonLoading = true;
          await this.validateUser();
          this.buttonLoading = false;
          return this.secondStepValid;
          break;
        case 3:
          await this.validateOTP();
          return this.thirdStepValid;
          break;
        case 4:
          await this.reestablecerPassword();
          return this.fourthStepValid;
          break;
        default:
          return false;
      }
    } else {
      return false;
    }
  }

  public async nextStep() {
    if (await this.canContinue()) {
      this.formIndex++;
      this.captchaToken = "";
    }
  }

  public async validateForm() {
    let isValid: boolean = false;
    if (!(this.$refs.currentPasswordForm as any)) {
      return isValid;
    }
    isValid = await (
      this.$refs.currentPasswordForm as VeeValidateForm
    ).validate();
    return isValid;
  }

  public onCaptchaSuccess(token: any) {
    this.captchaToken = token;
  }
  public onCaptchaExpire(result: any) {
    this.captchaToken = "";
  }

  public goBack() {
    if (this.formIndex > 1 && !this.showNoDataError) {
      switch (this.formIndex) {
        case 1:
          this.viaRecuperacionValue = "";
          this.viaRecuperacionValue = "";
          break;
        case 2:
          this.cedulaAfiliado = "";
          this.showSecondStepError = false;
          break;
        case 3:
          this.showCodeOTPErrorMessage = false;
          this.showSecondStepError = false;
          this.OTPCodeTextInput = "";
          this.viaRecuperacionValue = "";
          break;
        case 4:
          this.OTPCodeTextInput = "";
          this.cambioPasswordRequest.newPasswordRepeat = "";
          this.cambioPasswordRequest.newPassword = "";
          break;
      }

      this.formIndex--;
      this.captchaToken = "";
    } else {
      this.$router.push("/login");
    }
  }
  public showSuccessAlert(message: string = "") {
    Swal.fire({
      html: message.length > 0 ? message : "",
      showConfirmButton: false,
      icon: "success",
      timer: 3000,
    }).then((x) => {
      this.goLogin();
    });
  }
  public showErrorAlert(
    message: string = "Lo sentimos, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
    buttonText: string = "Ok",
    allowOutsideClick: boolean = true,
    goMenu: boolean = false,
    html: boolean = false
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: allowOutsideClick,
      confirmButtonText: buttonText,
      allowOutsideClick,
      html: html ? message : "",
    }).then((x) => {
      if (goMenu) {
        this.returnHome();
      } else {
        location.reload();
      }
    });
  }
  public viaNotificacionSelected(e: string) {
    this.viaComunicacionCheckValue = e;
    this.cambioPasswordRequest.valorValidar = e;
    this.viaRecuperacionValue = "";
  }

  get cedulaNumbersOnly() {
    let value = this.cedulaAfiliado;
    value = value.replace(/_/g, "");
    value = value.replace(/-/g, "");
    value = value.replace(/[{()}]/g, "");
    this.cambioPasswordRequest.codUsuario = value;
    return value;
  }

  public async validateUser() {
    try {
      if (this.timesOTCSend >= 4) {
        this.showErrorAlert(
          "Lo sentimos, ha excedido la cantidad máxima de intentos. Vuelva a intentarlo más tarde."
        );
        return;
      }

      var result = await this.CambioPasswordService.validateUsuario(
        this.cambioPasswordRequest
      );
      if (
        result &&
        result.data != null &&
        result.data.payload != null &&
        result.data.payload.success == true
      ) {
        this.cambioPasswordRequest.idToken = result.data.payload.idToken;
        this.timesOTCSend++;

        this.showSecondStepError = false;
      } else {
        if (result.data.payload.code == 204) {
          this.showSecondStepError = true;
        } else {
          this.showErrorAlert(
            "Ha ocurrido un error en la comunicación, intente más tarde."
          );
        }
      }
      this.buttonLoading = false;
    } catch (x) {
      this.showErrorAlert(
        "Ha ocurrido un error en la comunicación, intente más tarde."
      );
      console.log(x);
      this.buttonLoading = false;
    }
  }

  public async validateOTP() {
    try {
      var result = await this.CambioPasswordService.validateOTP(
        this.cambioPasswordRequest
      );
      // console.log("result.data",result.data)
      if (result && result.data && result.data.payload) {
        this.OTPValidationSuccsess = result.data.payload.success;

        if (!result.data.payload.success && result.data.payload.code == 200) {
          this.showCodeOTPErrorMessage = true;
        } else if (
          !result.data.payload.success &&
          result.data.payload.code == 530
        ) {
          this.showErrorAlert(
            "Tu sesión ha expirado, debes volver a iniciar el proceso para cambiar tu contraseña. Si necesitas ayuda contáctanos a nuentro Centro de Atención Telefónica al teléfono <a style='color: #0f6cbc;'>829-567-2371.</a>",
            "Ok",
            true,
            true,
            true
          );
        }
      } else {
        this.OTPValidationSuccsess = false;
      }

      if (result.data.payload.httpStatus == 400) {
        this.showCodeOTPErrorMessage = true;
      }
    } catch (error) {
      this.OTPValidationSuccsess = false;
      //ojo show error here
    }
  }

  public async reestablecerPassword() {
    try {
      // console.log("this.cambioPasswordRequest", this.cambioPasswordRequest)
      this.buttonLoading = true;
      var result = await this.CambioPasswordService.reestablecerPassword(
        this.cambioPasswordRequest
      );
      if (result.data.payload.success) {
        this.passwordResestSuccess = true;
        this.showSuccessAlert(
          "Su contraseña ha sido configurada correctamente. Ya puede ingresar a Mi Siembra."
        );
      } else {
        this.showErrorAlert(result.data.payload.message);
        this.passwordResestSuccess = false;
      }
      this.buttonLoading = false;
    } catch (error) {
      this.buttonLoading = false;
      this.showErrorAlert();
      // console.log(error)
    }
  }
  @Watch("viaRecuperacionValue")
  public viaRecuperacionValueWatch(newValue) {
    if (this.viaComunicacionCheckValue == "celular") {
      newValue = newValue.replace(/_/g, "");
      newValue = newValue.replace(/-/g, "");
      newValue = newValue.replace(/[{()}]/g, "");
    }
    this.cambioPasswordRequest.valor = newValue;
  }
  @Watch("OTPCodeTextInput")
  public OTPCodeTextInputWatch(newValue) {
    this.cambioPasswordRequest.token = newValue;
    this.showCodeOTPErrorMessage = false;
  }

  @Watch("cambioPasswordRequest.newPassword")
  public newPasswordWatch(v) {
    if (v != null) {
      this.passCumpleMin = v.length >= 10;

      this.passMayus = !!v
        .replace(/[^a-zA-Z]/gm, "")
        .split("")
        .find((x) => x === x.toUpperCase());
    }

    this.passMinus = !!v
      .replace(/[^a-zA-Z]/gm, "")
      .split("")
      .find((x) => x === x.toLowerCase());

    if (/\d/.test(v)) {
      this.passNum = true;
    } else {
      this.passNum = false;
    }

    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(v)) {
      this.passSpecial = true;
    } else {
      this.passSpecial = false;
    }
  }

  get passCoinciden() {
    return (
      this.cambioPasswordRequest.newPassword?.length > 0 &&
      this.cambioPasswordRequest.newPasswordRepeat?.length > 0 &&
      this.cambioPasswordRequest.newPassword ===
        this.cambioPasswordRequest.newPasswordRepeat
    );
  }

  get passObligatorio() {
    return (
      this.cambioPasswordRequest.newPassword?.length > 0 &&
      this.cambioPasswordRequest.newPasswordRepeat?.length > 0
    );
  }

  goLogin() {
    window.location.href = GlobalConfig.BASE_URL + "/login";
  }

  public countdown() {
    this.timer = 70;
    let interval = setInterval(() => {
      if (this.timer === 0) {
        clearInterval(interval);
      } else {
        this.timer--;
      }
    }, 1000);
  }

  public showWarningAlert() {
    Swal.fire({
      title: "",
      text: "El afiliado consultado no está registrado como cliente en nuestra base de datos. Para más información llámanos al 809-567-2371 o 1-809-200-2371 desde el interior sin cargos.",
      icon: "warning",
    });
  }
  public async reenviarOTP() {
    this.reenviarLoading = true;
    await this.validateUser();
    this.reenviarLoading = false;
  }

  public async hendleEncryptParams() {
    // console.log("1")
    try {
      if (this.$route.query.params) {
        // console.log("2")
        let params = this.$route.query.params.toString();
        params = params.replace(/\s/g, "+");
        // console.log("3")
        var base64String = Buffer.from(params, "hex").toString("base64");
        let decypt = this.afiliadoService.decryptByDES(base64String);
        // console.log(decypt)

        let decrypted = JSON.parse(decypt);
        this.userData = new UserData(decrypted);

        this.viaComunicacionCheckValue = decrypted?.valor;
        this.cambioPasswordRequest.valor = decrypted?.valor;
        this.cambioPasswordRequest.valorValidar = decrypted?.valorValidar;
        this.cambioPasswordRequest.codUsuario = decrypted?.codUsuario;
        this.cambioPasswordRequest.token = decrypted?.token;
        this.cambioPasswordRequest.canal = "PortalBe";
        this.cambioPasswordRequest.origenP2000 = decrypted?.origenP2000;
        this.cambioPasswordRequest.idToken = decrypted?.idToken;
        await this.validateOTP();
        this.formIndex = 4;
        this.countdown();
      } else {
        return;
      }
    } catch (e) {
      //  console.log("error decencriptando " ,e)
      // alert("eror ocn json")
      // this.$router.push('/home')
    }
  }

  get showVolver(): boolean {
    if (
      this.$route.query.params != null &&
      this.$route.query.params.length > 0 &&
      this.formIndex == 4
    ) {
      return false;
    }
    return true;
  }
}
